module.exports = __webpack_public_path__ + "static/media/social-facebook-32px.8e1b964d.svg";